module.exports = __webpack_public_path__ + "img/maylor2.5edf766b.png";